import PageTitle from "../../ui/PageTitle/PageTitle";
import WelcomeCard from "../../ui/WelcomeCard/WelcomeCard";

import { createStructuredSelector } from "reselect";
import {
  selectAccessFromInternet,
  selectUserInfo,
} from "../../App/module/selectors";

import { IUserInfo, UserSections } from "../../models/User";

import { FormattedMessage } from "react-intl";
import messages from "./module/messages";

import { push } from "connected-react-router";
import { connect } from "react-redux";
import { ROUTES } from "../../module/constants";

import { useEffect, useState } from "react";
import {
  FaClock,
  FaLockOpen,
  FaQuestion,
  FaTasks,
  FaUnlockAlt,
} from "react-icons/fa";
import {
  MdAdminPanelSettings,
  MdHistory,
  MdManageAccounts,
  MdMenuBook,
  MdNotes,
  MdOutlineFactCheck,
  MdOutlineLibraryBooks,
  MdOutlineManageSearch,
  MdOutlinePersonAddAlt,
  MdOutlinePersonSearch,
  MdOutlinePostAdd,
  MdOutlineSettings,
  MdWysiwyg,
} from "react-icons/md";
import { CgDanger } from "react-icons/cg";
import { RiRobotLine } from "react-icons/ri";
import { loadTableConfigurationAction } from "../../common/TablesConfiguration/tcActions";
import { ITableConfiguration } from "../../common/TablesConfiguration/tcConstants";
import { selectTablesConfiguration } from "../../common/TablesConfiguration/tcSelectors";
import CustomModal from "../../components/Modals/CustomModal/CustomModal";
import { loadApprovalBadge, loadNotify, loadTaskBadge } from "./module/actions";
import {
  notificationSelector,
  numApprovalSelector,
  numTaskSelector,
} from "./module/selectors";
import classes from "./Welcome.module.scss";
import { loadConfigurationsAction } from "../../store/global/actions";
import { isEmpty } from "ramda";

interface IWelcomeProps {
  userInfo: IUserInfo;
  loadTablesConfiguration: () => {};
  tablesConfiguration: ITableConfiguration[];
  numTask: number;
  numAppr: number;
  notification: IWelcomeNotif[];
  loadTaskBadge: () => void;
  loadApprovalBadge: () => void;
  loadGlobalConfig: () => void;
  checkNotify: () => void;
  isFromInternet: boolean;
}

interface IWelcomeNotif {
  title: string;
  message: string;
}

function Welcome(props: IWelcomeProps) {
  const {
    userInfo,
    loadTablesConfiguration,
    numTask,
    numAppr,
    notification,
    isFromInternet,
    loadTaskBadge,
    loadApprovalBadge,
    loadGlobalConfig,
    checkNotify,
  } = props;

  const [showNotify, setShowNotify] = useState(false);
  const [showConsoleAdmin, setShowConsoleAdmin] = useState(false);
  const [showTask, setShowTask] = useState(false);

  useEffect(() => {
    if (!isEmpty(userInfo)) {
      if (userInfo && userInfo.sections) {
        console.log("userInfo", userInfo);
        if (userInfo.sections.includes(UserSections.TASK)) loadTaskBadge();
        if (userInfo.sections.includes(UserSections.APPROVALS))
          loadApprovalBadge();
      }

      loadGlobalConfig();
      loadTablesConfiguration();
      checkNotify();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.id]);

  useEffect(() => {
    if (notification && notification.length > 0) {
      setShowNotify(true);
    } else {
      setShowNotify(false);
    }
  }, [notification]);

  useEffect(() => {
    if (isFromInternet) {
      setShowConsoleAdmin(false);
      setShowTask(false);
    } else {
      setShowConsoleAdmin(true);
      setShowTask(true);
    }
  }, [isFromInternet]);

  return (
    <>
      <CustomModal
        title={
          notification.length === 1 ? (
            notification[0].title
          ) : (
            <FormattedMessage {...messages.notifyTitle} />
          )
        }
        show={showNotify}
        onClose={() => setShowNotify(false)}
        message={
          <>
            {notification &&
              notification.map((el, i) => (
                <div key={el.title + el.message + i}>
                  <>{el.message}</>
                  {notification.length > 1 && <hr />}
                </div>
              ))}
          </>
        }
      />

      <PageTitle title={messages.pageTitle} />
      <div className={classes["welcome-wrapper"]}>
        <div className="container">
          {userInfo &&
            userInfo.sections &&
            (userInfo.sections.includes(UserSections.HISTORY_REQUEST) ||
              userInfo.sections.includes(UserSections.EXAMINE_USERS) ||
              userInfo.sections.includes(
                UserSections.EXAMINE_ENTITLEMENTS
              )) && (
              <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
                  <FormattedMessage {...messages.panelTitleConsultation} />
                </div>
                <hr />
                <div className={`${classes["section-welcome-nav-body"]}`}>
                  {userInfo.sections.includes(UserSections.HISTORY_REQUEST) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.requestHistory} />
                        }
                        desc={
                          <FormattedMessage {...messages.requestHistoryDesc} />
                        }
                        icon={<MdHistory />}
                        url={ROUTES.REQUESTHISTORY}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.EXAMINE_USERS) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.users} />}
                        desc={<FormattedMessage {...messages.usersDesc} />}
                        icon={<MdOutlinePersonSearch />}
                        url={ROUTES.USERSREFERENCE}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(
                    UserSections.EXAMINE_ENTITLEMENTS
                  ) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage
                            {...messages.entitlementReference}
                          />
                        }
                        desc={
                          <FormattedMessage
                            {...messages.entitlementReferenceDesc}
                          />
                        }
                        icon={<MdOutlineManageSearch />}
                        url={ROUTES.ENTITLEMENT_REFERENCE}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(
                    UserSections.USER_ENTITLEMENTS
                  ) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.userEntitlements} />
                        }
                        desc={
                          <FormattedMessage {...messages.userEntitlementDesc} />
                        }
                        icon={<MdOutlineManageSearch />}
                        url={ROUTES.USER_ENTITLEMENT}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

          {userInfo &&
            userInfo.sections &&
            (userInfo.sections.includes(UserSections.CATALOG) ||
              userInfo.sections.includes(
                UserSections.USER_ENTITLEMENT_REQUEST
              ) ||
              userInfo.sections.includes(UserSections.TEMPORARY_ABILITATIONS) ||
              userInfo.sections.includes(UserSections.RACF_USER)) && (
              <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
                  <FormattedMessage
                    {...messages.panelTitleManagementEntitlement}
                  />
                </div>
                <hr />
                <div className={`${classes["section-welcome-nav-body"]}`}>
                  {userInfo.sections.includes(UserSections.CATALOG) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.catalog} />}
                        desc={<FormattedMessage {...messages.catalogDesc} />}
                        icon={<MdOutlineLibraryBooks />}
                        url={ROUTES.CATALOG}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(
                    UserSections.USER_ENTITLEMENT_REQUEST
                  ) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.abilitationRequest} />
                        }
                        desc={
                          <FormattedMessage
                            {...messages.abilitationRequestDesc}
                          />
                        }
                        icon={<MdOutlinePostAdd />}
                        url={ROUTES.ABILITATIONREQUEST}
                      />
                    </div>
                  )}

                  {userInfo.sections.includes(
                    UserSections.TEMPORARY_ABILITATIONS
                  ) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage
                            {...messages.temporaryAbilitations}
                          />
                        }
                        desc={
                          <FormattedMessage
                            {...messages.temporaryAbilitationsDesc}
                          />
                        }
                        icon={<FaClock />}
                        url={ROUTES.TEMPORARY_ABILITATIONS}
                      />
                    </div>
                  )}

                  {userInfo.sections.includes(UserSections.RACF_USER) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.emergencyUsers} />
                        }
                        desc={
                          <FormattedMessage {...messages.emergencyUsersDesc} />
                        }
                        icon={<CgDanger />}
                        url={ROUTES.EMERGENCY_USERS}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.TECHNICAL_USERS) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.technicalUsers} />
                        }
                        desc={
                          <FormattedMessage {...messages.technicalUsersDesc} />
                        }
                        icon={<RiRobotLine />}
                        url={ROUTES.TECHNICAL_USERS}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

          {userInfo &&
            userInfo.sections &&
            (userInfo.sections.includes(UserSections.DELEGATIONS) ||
              userInfo.sections.includes(UserSections.APPROVALS) ||
              userInfo.sections.includes(UserSections.TASK) ||
              userInfo.sections.includes(UserSections.SERVICE_REQUEST) ||
              userInfo.sections.includes(UserSections.REPORTS) ||
              userInfo.sections.includes(UserSections.MANUALS) ||
              userInfo.sections.includes(UserSections.EXTERNAL_PORTAL) ||
              userInfo.sections.includes(UserSections.CONSOLE_ADMIN)) && (
              <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
                  <FormattedMessage {...messages.panelTitleOther} />
                </div>
                <hr />
                <div className={`${classes["section-welcome-nav-body"]}`}>
                  {userInfo.sections.includes(UserSections.DELEGATIONS) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.delegates} />}
                        desc={<FormattedMessage {...messages.delegatesDesc} />}
                        icon={<MdOutlinePersonAddAlt />}
                        url={ROUTES.DELEGATES}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.APPROVALS) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.approvals} />}
                        desc={<FormattedMessage {...messages.approvalsDesc} />}
                        icon={<MdOutlineFactCheck />}
                        url={ROUTES.APPROVALS}
                        showBadge={numAppr > 0}
                        badgeValue={numAppr}
                      />
                    </div>
                  )}
                  {showTask &&
                    userInfo.sections.includes(UserSections.TASK) && (
                      <div className="d-flex justify-content-center">
                        <WelcomeCard
                          title={<FormattedMessage {...messages.task} />}
                          desc={<FormattedMessage {...messages.taskDesc} />}
                          icon={<FaTasks />}
                          url={ROUTES.TASKS}
                          showBadge={numTask > 0}
                          badgeValue={numTask}
                        />
                      </div>
                    )}
                  {userInfo.sections.includes(UserSections.SERVICE_REQUEST) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.serviceRequest} />
                        }
                        desc={
                          <FormattedMessage {...messages.serviceRequestDesc} />
                        }
                        icon={<FaQuestion />}
                        url={ROUTES.SERVICE_REQUEST}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.REPORTS) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.reports} />}
                        desc={<FormattedMessage {...messages.reportsDesc} />}
                        icon={<MdNotes />}
                        url={ROUTES.REPORT}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.MANUALS) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.manuals} />}
                        desc={<FormattedMessage {...messages.manualsDesc} />}
                        icon={<MdMenuBook />}
                        url={ROUTES.MANUALS}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.EXTERNAL_PORTAL) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.externalPortal} />
                        }
                        desc={
                          <FormattedMessage {...messages.externalPortalDesc} />
                        }
                        icon={<MdWysiwyg />}
                        url={ROUTES.EXTERNAL_PORTAL}
                      />
                    </div>
                  )}
                  {showConsoleAdmin &&
                    userInfo.sections.includes(UserSections.CONSOLE_ADMIN) && (
                      <div className="d-flex justify-content-center">
                        <WelcomeCard
                          title={
                            <FormattedMessage {...messages.consoleAdmin} />
                          }
                          desc={
                            <FormattedMessage {...messages.consoleAdminDesc} />
                          }
                          icon={<MdOutlineSettings />}
                          url={ROUTES.CONSOLE_ADMIN}
                        />
                      </div>
                    )}
                </div>
              </div>
            )}

          {userInfo &&
            userInfo.sections &&
            userInfo.sections.includes(UserSections.BUSINESS_ROLE) && (
              <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
                  <FormattedMessage {...messages.panelTitleBr} />
                </div>
                <hr />
                <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                  <WelcomeCard
                    title={<FormattedMessage {...messages.br} />}
                    desc={<FormattedMessage {...messages.brDesc} />}
                    icon={<MdOutlinePersonAddAlt />}
                    url={ROUTES.BR_MANAGEMENT}
                  />
                </div>
              </div>
            )}

          {userInfo &&
            userInfo.sections &&
            (userInfo.sections.includes(UserSections.PROFILE_MGMT) ||
              userInfo.sections.includes(UserSections.RESET_PWD) ||
              userInfo.sections.includes(UserSections.CHANGE_PWD)) && (
              <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
                  <FormattedMessage {...messages.panelTitlePwd} />
                </div>
                <hr />
                <div className={`${classes["section-welcome-nav-body"]}`}>
                  {userInfo.sections.includes(UserSections.PROFILE_MGMT) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage
                            {...messages.profileManagementTitle}
                          />
                        }
                        desc={
                          <FormattedMessage
                            {...messages.profileManagementDesc}
                          />
                        }
                        icon={<MdManageAccounts />}
                        url={ROUTES.PROFILE_MGMT}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.RESET_PWD) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={<FormattedMessage {...messages.resetPassword} />}
                        desc={
                          <FormattedMessage {...messages.resetPasswordDesc} />
                        }
                        icon={<FaUnlockAlt />}
                        url={ROUTES.RESET_PASSWORD}
                      />
                    </div>
                  )}
                  {userInfo.sections.includes(UserSections.CHANGE_PWD) && (
                    <div className="d-flex justify-content-center">
                      <WelcomeCard
                        title={
                          <FormattedMessage {...messages.changePassword} />
                        }
                        desc={
                          <FormattedMessage {...messages.changePasswordDesc} />
                        }
                        icon={<FaLockOpen />}
                        url={ROUTES.CHANGE_PASSWORD}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

          {userInfo &&
            userInfo.sections &&
            userInfo.sections.includes(UserSections.EXAMINE_CAMPAIGN) && (
              <div className={`row p-3 m-3 ${classes["section-welcome-nav"]}`}>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left p-1">
                  <FormattedMessage {...messages.panelTitleCertification} />
                </div>
                <hr />
                {userInfo.sections.includes(UserSections.EXAMINE_CAMPAIGN) && (
                  <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                    <WelcomeCard
                      title={<FormattedMessage {...messages.recertification} />}
                      desc={
                        <FormattedMessage {...messages.recertificationDesc} />
                      }
                      icon={<MdAdminPanelSettings />}
                      url={ROUTES.CERTIFICATION_REFERENCE}
                    />
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    userInfo: selectUserInfo,
    tablesConfiguration: selectTablesConfiguration,
    numTask: numTaskSelector,
    numAppr: numApprovalSelector,
    notification: notificationSelector,
    isFromInternet: selectAccessFromInternet,
  });

const mapDispatchToProps: any = {
  changeLocation: (url: string) => push(url),
  loadTablesConfiguration: loadTableConfigurationAction,
  loadTaskBadge: loadTaskBadge,
  loadApprovalBadge: loadApprovalBadge,
  loadGlobalConfig: loadConfigurationsAction,
  checkNotify: loadNotify,
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Welcome);
